(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/result-boxes/assets/javascripts/views/final-distribution.js') >= 0) return;  svs.modules.push('/components/sport/result-boxes/assets/javascripts/views/final-distribution.js'); 
'use strict';

svs.sport.result_boxes.views.FinalDistribution = Marionette.View.extend({
  template: function(data) {
    return svs.sport.result_boxes.templates.final_distribution(data);
  },

  ui: {
    result: '.distribution'
  },

  regions: {
    payout: '#distribution-container'
  }
});

 })(window);